import { render, staticRenderFns } from "./AddFlow.vue?vue&type=template&id=b1699a08"
import script from "./AddFlow.vue?vue&type=script&lang=js"
export * from "./AddFlow.vue?vue&type=script&lang=js"
import style0 from "./AddFlow.vue?vue&type=style&index=0&id=b1699a08&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports